import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="旧ポートフォリオサイト" link="https://www.tonoyama.me/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
React で実装し、AWS Amplify で継続的デプロイを行いました。
    </ProjectCard>
    <ProjectCard title="技術ブログ" link="https://blog.tonoyama-yudai.com" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
毎週更新が目標の技術ブログです。
    </ProjectCard>
    <ProjectCard title="医療情報システム" link="https://github.com/Tonoyama/OpenCloudMedical" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
オープンソースのクラウド医療情報システムです。
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      